<script>
import Layout from '@layouts/primary'
// import { RRule, RRuleSet, rrulestr } from 'rrule'
import { clientReportMethods } from '@state/helpers'
import palette from 'google-palette';
export default {
  $_veeValidate: {
    validator: 'new',
  },
  page: {
    title: 'Recycling Reports',
    meta: [{ name: 'recycling-reports', content: 'Recycling Reports' }],
  },
  components: { Layout },
  data() {
    return {
      search: '',
      headersOne:[],
      headersTwo:[
        {text:"Type",value:"name"},
        {text:"Jan",value:"jan"},
        {text:"Feb",value:"feb"},
        {text:"Mar",value:"mar"},
        {text:"Apr",value:"apr"},
        {text:"May",value:"may"},
        {text:"Jun",value:"jun"},
        {text:"Jul",value:"jul"},
        {text:"Aug",value:"aug"},
        {text:"Sep",value:"sep"},
        {text:"Oct",value:"oct"},
        {text:"Nov",value:"nov"},
        {text:"Dec",value:"dec"},
      ],
      pieChartHeaders:[],
      pieChartValues:{},
      pieChartValuesArray:[],
      barChartValues:[],

      itemsOne:[],
      itemsTwo:[],
      monthlyTotals:[],
      bgColors:[],
      dataParsed:false,
    }
  },
  mounted() {
    this.$validator.localize('en', this.dictionary)
    this.getClientCollectionData().then(response => {
      let obj = this.$store.state.clientreports.objects
      const headers = [];
      headers.push({text:"Date",value:"date"});
      for (const type in obj.wasteTypes){
        headers.push(obj.wasteTypes[type]);
        this.pieChartHeaders.push(obj.wasteTypes[type].text);
      }
      for (const collectionInfo of obj.collectionsBreakdown){
        if(this.pieChartValues[collectionInfo.type] == null){
          this.pieChartValues[collectionInfo.type] = 0;
        }
        this.pieChartValues[collectionInfo.type] += collectionInfo.amount;
      }
      for (const type in obj.wasteTypes){
        this.pieChartValuesArray.push(this.pieChartValues[obj.wasteTypes[type].text])
      }
      for (const collection in obj.collections){
        let data = JSON.parse(obj.collections[collection].collection);
        this.itemsOne.push(data)
      }
      const seq = palette('mpn65', this.pieChartHeaders.length);
      for (const i of seq){
        this.bgColors.push("#"+i)
      }
      for(const labelHeader in this.pieChartHeaders){
        this.barChartValues.push({label:this.pieChartHeaders[labelHeader],backgroundColor: this.bgColors[labelHeader],data:[this.pieChartValuesArray[labelHeader]]})
      }

      this.headersOne = headers;
      this.items = obj.collectionsBreakdown
      this.dataParsed = true;
      this.itemsTwo = obj.ytdweight
      this.monthlyTotals = [obj.ytdmonthlytotals]

    })
  },
  methods: {
    ...clientReportMethods,
    submit() {
      this.$validator.validateAll()

    },
    clear() {

    },
    changeRoute(r) {
      this.$router.push(r)
    },
  },
}
</script>

<template>
  <Layout>
    <VContainer>
      <h2 :class="$style.routeHeader">
        Waste Reports
      </h2>
      <template>
        <div slot="header">
          <h3>
            Weight & Collection Data Breakdown
          </h3>
        </div>
        <VCard>
          <VDataTable
            :headers="headersOne"
            :items="itemsOne"
          >
            <template
              slot="items"
              slot-scope="props"
            >
              <td
                v-for="firstHeader in headersOne"
                :key="firstHeader.value"
              >
                {{ props.item[firstHeader.value] ? props.item[firstHeader.value] : 0 }}
              </td>
            </template>
          </VDataTable>
        </VCard>
        <br>
        <div slot="header">
          <h3>
            Percentage Pie Chart by Weight
          </h3>
        </div>
        <br>
        <VCard v-if="dataParsed">
          <BasePieGraphPercentage
            :labels="pieChartHeaders"
            :options="{responsive: true, maintainAspectRatio: false }"
            :data="pieChartValuesArray"
            :colors="bgColors"
          />
        </VCard>
        <br>
        <div slot="header">
          <h3>
            Total Weights
          </h3>
        </div>
        <br>
        <VCard v-if="dataParsed">
          <BaseBarGraph
            :options="{responsive: true, maintainAspectRatio: false }"
            :data="barChartValues"
          />
        </VCard>
      </template>
      <br>
      <div v-if="dataParsed">
        <VDataTable
          :headers="headersTwo"
          :items="itemsTwo"
          hide-actions
        >
          <template
            slot="items"
            slot-scope="props"
          >
            <td 
              v-for="header in headersTwo" 
              :key="header.value"
            >
              {{ props.item[header.value] ? props.item[header.value] : 0 }}
            </td>
          </template>
        </VDataTable>
      </div>
      <br>
      <div v-if="dataParsed">
        <VDataTable
          :headers="headersTwo"
          :items="monthlyTotals"
          hide-actions
        >
          <template
            slot="items"
            slot-scope="props"
          >
            <td
              v-for="secondHeader in headersTwo"
              :key="props.item[secondHeader]"
            >
              {{ props.item[secondHeader.value] ? props.item[secondHeader.value] : 0 }}
            </td>
          </template>
        </VDataTable>
      </div>
    </VContainer>
  </Layout>
</template>

<style lang="scss" module>
    @import '@design';

    .routeHeader {
        display: inline-block;
    }

    .addButton {
        display: inline-block;
        float: right;
    }
</style>
